import React from 'react'
import styles from './styles.module.scss'

export default function PureTitle({ title, subTitle, isRequired, titleCss, subTitleCSS }) {
  return (
    <div className={styles.titleContainer}>
      <h2 className={`${styles.title} ${titleCss} ${isRequired && styles.titleWithRequired}`}>{title}</h2>
      {subTitle && subTitle.length > 0 && <h3 className={`${styles.subTitle} ${subTitleCSS}`}>{subTitle}</h3>}
    </div>
  )
}
